import React, { useState } from "react";
import { Link } from "react-router-dom";
import { supabase, supabaseEnabled } from "../lib/supabase";
import { setDevToken } from "../lib/api";
import { C, card, btn, input, label } from "../lib/theme";

const DEV = import.meta.env.VITE_AUTH_DEV === "true";

export default function Login({ onLogin }) {
  const [mode, setMode] = useState("signin");     // signin | signup
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true); setErr(""); setMsg("");
    try {
      if (mode === "signup") {
        const { data, error } = await supabase.auth.signUp({ email: email.trim(), password: pw });
        if (error) throw error;
        if (data.session) onLogin();                         // confirmations disabled
        else setMsg("Check your email for a verification link, then come back and sign in.");
      } else {
        const { error } = await supabase.auth.signInWithPassword({ email: email.trim(), password: pw });
        if (error) throw error;
        onLogin();
      }
    } catch (e) {
      setErr(/confirm/i.test(e.message)
        ? "Please verify your email first — check your inbox for the link."
        : e.message);
    } finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: C.bg, color: C.text, display: "flex",
      alignItems: "center", justifyContent: "center", fontFamily: C.font, padding: 16 }}>
      <div style={{ ...card, width: 420, maxWidth: "100%" }}>
        <div style={{ fontFamily: C.displayFont, fontSize: 26, marginBottom: 4 }}>Astrology Calendar</div>

        {!supabaseEnabled && !DEV ? (
          <div style={{ fontSize: 12.5, color: C.rose, lineHeight: 1.6 }}>
            Auth isn't configured. Set <code>VITE_SUPABASE_URL</code> and
            <code> VITE_SUPABASE_ANON_KEY</code> in the frontend environment.
          </div>
        ) : (
          <>
            {supabaseEnabled && (
              <>
                <div style={{ display: "flex", gap: 6, margin: "12px 0 16px" }}>
                  {["signin", "signup"].map((m) => (
                    <button key={m} onClick={() => { setMode(m); setErr(""); setMsg(""); }}
                      style={{ flex: 1, background: mode === m ? C.brass : C.surface2,
                        color: mode === m ? C.bg : C.dim, border: `1px solid ${mode === m ? C.brass : C.line}`,
                        borderRadius: 4, padding: "7px 0", fontSize: 13, cursor: "pointer",
                        fontFamily: "inherit", fontWeight: mode === m ? 700 : 400 }}>
                      {m === "signin" ? "Sign in" : "Create account"}
                    </button>
                  ))}
                </div>
                <div style={label}>EMAIL</div>
                <input type="email" value={email} autoComplete="email"
                  onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com"
                  style={{ ...input, width: "100%", boxSizing: "border-box", marginBottom: 10 }} />
                <div style={label}>PASSWORD</div>
                <input type="password" value={pw}
                  autoComplete={mode === "signup" ? "new-password" : "current-password"}
                  onChange={(e) => setPw(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter" && email && pw.length >= 6) submit(); }}
                  placeholder={mode === "signup" ? "At least 6 characters" : "Your password"}
                  style={{ ...input, width: "100%", boxSizing: "border-box", marginBottom: 12 }} />
                <button style={{ ...btn(), width: "100%" }} disabled={busy || !email || pw.length < 6}
                  onClick={submit}>
                  {busy ? "…" : mode === "signup" ? "Create account" : "Sign in"}
                </button>
                {msg && <div style={{ fontSize: 12, color: C.brass, marginTop: 10, lineHeight: 1.5 }}>{msg}</div>}
                {err && <div style={{ fontSize: 12, color: C.rose, marginTop: 10 }}>{err}</div>}
              </>
            )}

            {DEV && (
              <div style={{ marginTop: supabaseEnabled ? 18 : 0, paddingTop: supabaseEnabled ? 14 : 0,
                borderTop: supabaseEnabled ? `1px solid ${C.line}` : "none" }}>
                <div style={label}>DEV TOKEN (LOCAL ONLY)</div>
                <DevBox onLogin={onLogin} />
              </div>
            )}
          </>
        )}

        <div style={{ marginTop: 16, fontSize: 12 }}>
          <Link to="/calculator" style={{ color: C.brass }}>
            Or try the free ZR calculator — all eight lots, no signup →</Link>
        </div>
      </div>
    </div>
  );
}

function DevBox({ onLogin }) {
  const [tok, setTok] = useState("");
  return (
    <>
      <input value={tok} onChange={(e) => setTok(e.target.value)}
        placeholder="dev:<uuid>:<email>"
        style={{ ...input, width: "100%", boxSizing: "border-box", marginBottom: 8 }} />
      <button style={btn(false)} disabled={!tok.startsWith("dev:")}
        onClick={() => { setDevToken(tok); onLogin(); }}>Use dev token</button>
    </>
  );
}
